import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import React, { useState } from "react";
import { api } from "../../../../../../utility/AxiosInceptor";
import InventorySearchResult from "./search_result/search_result";

import { ProgressSpinner } from "primereact/progressspinner";

export default function InvenotorySearch() {
  const [searchInventoryBy, setSearchInventoryBy] = useState(null);
  const [loading, setIsLoading] = useState(false);

  function SearchInventory() {
    setIsLoading(true);

    api
      .get(`/api/web/search/searchInventory/${searchInventoryBy}`)
      .then((response) => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  }
  return (
    <Card style={{ width: "108.4rem" }} className="h-[100vh]">
      <h1 className="daterange pb-1">Invenotory Search</h1>
      <div
        style={{ gap: "0.8rem" }}
        className="mt-4 flex flex-wrap justify-content-around flex-row w-[100%]"
      >
        <div>
          <label className="mb-4 block">Enter MDN or ESN Or Contact No </label>
          <InputText
            value={searchInventoryBy}
            onChange={(e) => {
              setSearchInventoryBy(e.target.value);
            }}
            className="field-width"
          />
        </div>
        <div className="mt-4">
          <Button
            style={{ height: "3.5rem" }}
            onClick={SearchInventory}
            label="Search inventory"
            className="mt-4 field-width"
          />
        </div>
      </div>
      {loading ? (
        <ProgressSpinner className="justify-content-center flex mt-4" />
      ) : (
        <InventorySearchResult />
      )}
    </Card>
  );
}
